import { render, staticRenderFns } from "./UserOthers.vue?vue&type=template&id=559afe68&"
import script from "./UserOthers.vue?vue&type=script&lang=js&"
export * from "./UserOthers.vue?vue&type=script&lang=js&"
import style0 from "./UserOthers.vue?vue&type=style&index=0&id=559afe68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports